import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as history from "app/main/history";
import { observeResource } from "kea-resource";
import { resources, selectores, createSelectorRx } from "app/main/std";
import { createSelector } from "reselect";
import { NuevoPaqueteView } from "./form";
import { message } from "kea-react";

interface State {
    value: models.NuevoPaquetePPModel;
}
export class NuevoPaquete extends React.PureComponent<{}, State>{
    constructor(props: {}) {
        super(props);
        this.state = {
            value: {
                Pago: {
                    Conceptos: [],
                    EsCredito: false,
                    ImporteEfectivoAntesFeria: 0
                },
                Paquete: {} as any
            }
        }
    }

    onChange = (x: models.NuevoPaquetePPModel) => this.setState({ value: x });
    onAceptar = async () => {
        const value = this.state.value;
        const ret = await resources.PaquetePP.AgregarPaquetePP(value);
        history.go("../");

        const mensajeFac =  ret.ErrorFacturacion ? ("No se pudo facturar: " + ret.ErrorFacturacion ): "La factura fue generada correctamente" ;
        await message("Nuevo paquete de PP", "Se agregó el paquete de guías prepagadas. " + mensajeFac);
        location.reload();
        
    }
    render() {
        return <NuevoPaqueteView
            value={this.state.value}
            onChange={this.onChange}
            onAceptar={this.onAceptar}
        />
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/paquetespp/edit/index.tsx